import React, { useState } from 'react';
import { Section } from './Section';
import { Check, Gift, Trophy, BookOpen } from 'lucide-react';
type Pack = 'base' | 'premium';
const LINKS: Record<Pack, string> = {
  base: 'https://checkout.totaliadigital.com/cart/52771143942512:1',
  premium: 'https://checkout.totaliadigital.com/cart/53391977742704:1'
};
export function Pricing() {
  const [selected, setSelected] = useState<Pack>('premium');
  return <Section id="pricing" className="bg-gray-950" data-id="element-135">
      <div className="text-center mb-10" data-id="element-136">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-137">
          Elegí el pack ideal para vos
        </h2>
        <p className="text-lg text-gray-400" data-id="element-138">
          Un pago único. Acceso para siempre.
        </p>
      </div>

      <div className="max-w-lg mx-auto space-y-5 mb-10" data-id="element-139">
        {/* Pack Base */}
        <button type="button" onClick={() => setSelected('base')} className={`w-full text-left rounded-2xl p-5 transition-all duration-200 border-2 ${selected === 'base' ? 'border-sage-500 bg-gray-900' : 'border-gray-700 bg-gray-900/60 hover:border-gray-500'}`} data-id="element-140">
          <div className="flex items-start gap-4" data-id="element-141">
            {/* Radio */}
            <div className="mt-1 shrink-0" data-id="element-142">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected === 'base' ? 'border-sage-400' : 'border-gray-600'}`} data-id="element-143">
                {selected === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-sage-400" data-id="element-144" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-145">
              <div className="flex items-center gap-2 mb-1" data-id="element-146">
                <BookOpen size={20} className="text-sage-400" data-id="element-147" />
                <h3 className="text-xl font-bold text-white" data-id="element-148">PACK BASE</h3>
              </div>

              <div className="flex items-baseline gap-3 mb-3" data-id="element-149">
                <span className="text-3xl font-bold text-white" data-id="element-150">$18.790</span>
              </div>

              <div className="mb-2" data-id="element-151">
                <p className="text-xs font-semibold text-sage-400 uppercase tracking-wide mb-2" data-id="element-152">
                  Incluye:
                </p>
                <p className="text-sm text-gray-300" data-id="element-153">
                  1 Tomo principal de ejercicios cognitivos
                </p>
              </div>

              <div data-id="element-154">
                <p className="text-xs font-semibold text-[#e8a365] uppercase tracking-wide mb-2 flex items-center gap-1" data-id="element-155">
                  <Gift size={14} data-id="element-156" /> 2 Bonus:
                </p>
                <ul className="space-y-1" data-id="element-157">
                  <li className="flex items-center gap-2 text-sm text-gray-300" data-id="element-158">
                    <Check size={14} className="text-sage-500 shrink-0" data-id="element-159" />
                    Sopa de Letras
                  </li>
                  <li className="flex items-center gap-2 text-sm text-gray-300" data-id="element-160">
                    <Check size={14} className="text-sage-500 shrink-0" data-id="element-161" />
                    300 Sudokus para adultos
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </button>

        {/* Pack Premium */}
        <button type="button" onClick={() => setSelected('premium')} className={`w-full text-left rounded-2xl p-5 transition-all duration-200 border-2 relative ${selected === 'premium' ? 'border-sage-500 bg-gray-900 shadow-lg shadow-sage-500/10' : 'border-gray-700 bg-gray-900/60 hover:border-gray-500'}`} data-id="element-162">
          {/* Badges */}
          <div className="flex flex-wrap gap-2 mb-4 ml-9" data-id="element-163">
            <span className="inline-flex items-center gap-1 bg-[#e8a365] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-164">
              ★ Más Elegido
            </span>
            <span className="inline-flex items-center gap-1 bg-gray-700 text-sage-400 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide border border-sage-600/40" data-id="element-165">
              AHORRÁS $27.910
            </span>
          </div>

          <div className="flex items-start gap-4" data-id="element-166">
            {/* Radio */}
            <div className="mt-1 shrink-0" data-id="element-167">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected === 'premium' ? 'border-sage-400' : 'border-gray-600'}`} data-id="element-168">
                {selected === 'premium' && <div className="w-2.5 h-2.5 rounded-full bg-sage-400" data-id="element-169" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-170">
              <div className="flex items-center gap-2 mb-1" data-id="element-171">
                <Trophy size={20} className="text-[#e8a365]" data-id="element-172" />
                <h3 className="text-xl font-bold text-white" data-id="element-173">PACK PREMIUM</h3>
              </div>

              <div className="flex items-baseline gap-3 mb-3" data-id="element-174">
                <span className="text-3xl font-bold text-sage-400" data-id="element-175">
                  $27.990
                </span>
              </div>

              <ul className="space-y-2.5" data-id="element-176">
                <li className="flex items-start gap-2.5 text-sm text-gray-200" data-id="element-177">
                  <Check size={16} className="text-sage-400 shrink-0 mt-0.5" data-id="element-178" />
                  <span data-id="element-179">2 Tomos principales de ejercicios cognitivos</span>
                </li>

                <li className="pt-2 border-t border-gray-700/50" data-id="element-180">
                  <p className="text-xs font-semibold text-[#e8a365] uppercase tracking-wide mb-2 flex items-center gap-1" data-id="element-181">
                    <Gift size={14} data-id="element-182" /> 3 Bonus incluidos
                  </p>
                </li>

                <li className="flex items-start gap-2.5 text-sm text-gray-300" data-id="element-183">
                  <Check size={16} className="text-sage-500 shrink-0 mt-0.5" data-id="element-184" />
                  <span data-id="element-185">Sopa de Letras</span>
                </li>
                <li className="flex items-start gap-2.5 text-sm text-gray-300" data-id="element-186">
                  <Check size={16} className="text-sage-500 shrink-0 mt-0.5" data-id="element-187" />
                  <span data-id="element-188">Sudokus para adultos en 5 dificultades</span>
                </li>
                <li className="flex items-start gap-2.5 text-sm text-gray-300" data-id="element-189">
                  <Check size={16} className="text-sage-500 shrink-0 mt-0.5" data-id="element-190" />
                  <span data-id="element-191">+100 Mandalas a colorear</span>
                </li>
                <li className="flex items-start gap-2.5 text-sm text-gray-300" data-id="element-192">
                  <Check size={16} className="text-sage-500 shrink-0 mt-0.5" data-id="element-193" />
                  <span data-id="element-194">
                    Actualizaciones trimestrales con ejercicios nuevos{' '}
                    <span className="font-bold text-[#e8a365]" data-id="element-195">GRATIS</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </button>
      </div>

      {/* Main CTA Button */}
      <div className="max-w-lg mx-auto" data-id="element-196">
        <a href={LINKS[selected]} className="block w-full text-center py-5 px-8 rounded-2xl text-xl font-bold text-white bg-sage-600 hover:bg-sage-700 shadow-lg shadow-sage-600/30 transition-all duration-200 hover:-translate-y-1 active:translate-y-0" data-id="element-197">
          {selected === 'premium' ? '🏆 ELEGIR PACK PREMIUM' : '📘 ELEGIR PACK BASE'}
        </a>
        <div className="flex items-center justify-center gap-4 mt-4 text-xs text-gray-500" data-id="element-198">
          <span data-id="element-199">🔒 Compra segura</span>
          <span data-id="element-200">·</span>
          <span data-id="element-201">📩 Acceso inmediato</span>
          <span data-id="element-202">·</span>
          <span data-id="element-203">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </Section>;
}